<template>
  <b-modal
    :id="modalId"
    :title="title"
    size="lg"
    hide-footer
    @hidden="handleClose"
  >
    <QuickPromotionForm
      :embedded-on="embeddedOn"
      :embedded-on-id="embeddedOnId"
      :promotion-id="promotionId"
      :rate-plan-id="ratePlanId"
      :sales-channel-id="salesChannelId"
      :selected-date="selectedDate"
      @success="handleSuccess"
      @cancel="handleCancel"
    />
  </b-modal>
</template>

<script>
import QuickPromotionForm from './QuickPromotionForm.vue'

export default {
  name: 'QuickPromotionModal',
  components: {
    QuickPromotionForm
  },
  props: {
    modalId: {
      type: String,
      default: 'quick-promotion-modal'
    },
    embeddedOn: {
      type: String,
      required: true,
      validator: value => ['supplier', 'sales-channel'].includes(value)
    },
    embeddedOnId: {
      type: Number,
      required: true
    },
    promotionId: {
      type: Number,
      default: null
    },
    ratePlanId: {
      type: Number,
      default: null
    },
    salesChannelId: {
      type: Number,
      default: null
    },
    selectedDate: {
      type: String,
      default: null
    }
  },
  computed: {
    title() {
      return this.promotionId ? 'Edit Promotion' : 'Quick Add Promotion'
    }
  },
  methods: {
    handleSuccess() {
      this.$bvModal.hide(this.modalId)
      this.$emit('success')
    },
    handleCancel() {
      this.$bvModal.hide(this.modalId)
    },
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>
